import { Component, input, output } from '@angular/core';
import { DatePipe, SlicePipe } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { OfflineStateService } from '../../../offline/services/offline-state.service';
import { PendingRequest } from '../../../offline/services/pending-queue.service';
import type { SyncLogEntry } from '../topbar-company.collab';

/**
 * Panneau « Etat de synchronisation » de la barre du haut (application de bureau) : connexion,
 * requetes en attente, collections synchronisees.
 *
 * Presentationnel : l'etat de connexion est lu sur `offlineState` (signaux), la liste des requetes
 * et des journaux vient de la barre, qui recoit la fermeture. La barre decide de l'afficher.
 */
@Component({
  selector: 'app-topbar-sync-panel',
  standalone: true,
  imports: [DatePipe, SlicePipe, TranslateModule],
  templateUrl: './topbar-sync-panel.component.html',
  styleUrls: [
    '../styles/topbar-sync-panel-01.css',
  ],
  styles: [':host { display: contents; }'],
})
export class TopbarSyncPanelComponent {
  readonly showSyncPanel = input.required<boolean>();
  readonly offlineState = input.required<OfflineStateService>();
  readonly pendingRequests = input.required<PendingRequest[]>();
  readonly syncLogs = input.required<SyncLogEntry[]>();

  readonly closed = output<void>();
}
